import * as popUpStyles from "../styles/layout/search-pop-up.module.scss";

import CategoriesContainer from "../components/shared/CategoriesContainer";
import IconContainer from "../components/shared/IconContainer";
import PolyLink from "../components/shared/PolyLink";
import React from "react";
import {navigate} from "gatsby";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

const searchResultsPageByLanguage = {
    en: "search-results", fr: "resultats-de-recherche",
};

const idxSearchWebsiteToName = {
    fr: {
        'journee-portes-ouvertes-bachelor': 'Journee Portes Ouvertes Bachelor',
        'journee-portes-ouvertes-master': 'Journee Portes Ouvertes Master'
    }, en: {
        'journee-portes-ouvertes-bachelor': 'Journee Portes Ouvertes Bachelor',
        'journee-portes-ouvertes-master': 'Journee Portes Ouvertes Master'
    }
}


const toWebsitName = (name, language) => {
    if (!language || (language !== 'en' && language !== 'fr')) {
        language = 'fr'
    }
    const section = idxSearchWebsiteToName[language]
    if (section[name]) {
        return section[name]
    }

    return name
}

const buildHitResultUrl = (websiteRoot, slug, otherSiteRoot) => {
    if (!slug.startsWith("/")) {
        slug = `/${slug}`;
    }
    if (!websiteRoot) {
        websiteRoot = "";
    }
    if (otherSiteRoot) {
        if (websiteRoot.endsWith("/fr")) {
            websiteRoot = `/${otherSiteRoot}/fr`
        } else if (websiteRoot.endsWith("/en")) {
            websiteRoot = `/${otherSiteRoot}/en`
        } else {
            websiteRoot = `/${otherSiteRoot}`
        }
    }
    while (websiteRoot.endsWith("/")) {
        websiteRoot = websiteRoot.slice(0, -1);
    }
    return `${websiteRoot}${slug}`;
};

const HitColumns = ({
        hits, title, searchWords, type, websiteRoot, language, seeMore,
    }) => {
    const {t} = useTranslation();

    const getCategories = (hit) => {
        return [{
            label: t(`search.${hit.type}`), variant: "contained", basecolor: "var(--red-color)", type: hit.type,
        },];
    };

    const goToResults = () => {
        if (typeof window !== `undefined`) {
            const searchResultsPageUrl = searchResultsPageByLanguage[language];
            let searchPageUri = buildHitResultUrl(websiteRoot, searchResultsPageUrl);
            let url = `${searchPageUri}?q=${searchWords}&f=${type}`;
            if (`${searchPageUri}` === window.location.pathname) {
                window.location.href = url;
            } else {
                navigate(url);
            }
        }
    };

    return (<div style={{padding: 10}}>
        {title && <h2 className={popUpStyles.title}>{title}</h2>}
        <ul style={seeMore ? {overflow: "auto", maxHeight: "60vh"} : {}}>
            {hits?.map((hit, index) => {
                let url = buildHitResultUrl(websiteRoot, hit.slug, hit.website);
                return (<li key={`hits-${index}`} style={{marginTop: 20}}>
                    {!seeMore && (<CategoriesContainer
                        notFocusable={true}
                        elements={getCategories(hit)}
                        clickOff={true}
                    ></CategoriesContainer>)}

                    <div style={{marginBottom: 20}}>
                        <>

                            <PolyLink
                                url={url}
                                className={popUpStyles.searchItem + " searchResult"}
                            >
                                {hit.title}
                            </PolyLink>
                            {hit.website && (<span
                                className={popUpStyles.searchHitWebsite}>{toWebsitName(hit.website, null)}</span>)}
                        </>
                    </div>

                    {index < hits?.length - 1 && (<div className={popUpStyles.separator}/>)}
                </li>);
            })}
        </ul>
        {seeMore && (<div className={popUpStyles.toutVoir}>
            <button
                className={`${popUpStyles.toutVoirButtonPopUp} pointer`}
                aria-label={t(`search.results.goto`)}
                tabIndex="0"
                onClick={() => goToResults()}
                onKeyDown={() => goToResults()}
            >
                <div className={popUpStyles.popUpRedSeeMore}>
                    <IconContainer
                        icon="PLUS_SQUARE"
                        color="RED"
                        size={30}
                    ></IconContainer>
                </div>
                <span
                    className={popUpStyles.srOnly}>{"Voir plus de résultats dans la catégorie " + title}</span>
                <div className={popUpStyles.popUpWhiteSeeMore}>
                    <IconContainer
                        icon="PLUS_SQUARE"
                        color="WHITE"
                        size={30}
                    ></IconContainer>
                </div>
                <p className={clsx(popUpStyles.seeMore, popUpStyles.h6SeeMore)}>{t("nav.seeMore")}</p>
            </button>
        </div>)}
    </div>);
};

export default HitColumns;
